import { render, staticRenderFns } from "./cModalMedicAlmaPharmacy.vue?vue&type=template&id=2ca0f77c&scoped=true"
import script from "./cModalMedicAlmaPharmacy.vue?vue&type=script&lang=js"
export * from "./cModalMedicAlmaPharmacy.vue?vue&type=script&lang=js"
import style0 from "./cModalMedicAlmaPharmacy.vue?vue&type=style&index=0&id=2ca0f77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0f77c",
  null
  
)

export default component.exports